export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_PRODUCT_IN_CART = 'DELETE_PRODUCT_IN_CART';
export const UPDATE_PRODUCT_IN_CART = 'UPDATE_PRODUCT_IN_CART';
export const CHANGE_MESSAGE = 'CHANGE_MESSAGE';


// WEBPACK FOOTER //
// ./src/constants/ActionType.js